import { ObjectTools } from '@sol/components/tools/object-tools';
import { SolPopover } from '@sol/components';

export class SolPopoversState {
  private constructor(
    public readonly popovers: SolPopover<any>[],
    public readonly visible: boolean,
  ) {}

  public static of(): SolPopoversState {
    return new SolPopoversState([], false);
  }

  public withPopovers(popovers: SolPopover<any>[]): SolPopoversState {
    return this.copy({ popovers }).recalculate();
  }

  private recalculate(): SolPopoversState {
    const visible = this.popovers.length > 0;
    return this.copy({ visible });
  }

  private copy(props: Partial<SolPopoversState>): SolPopoversState {
    return ObjectTools.copy<SolPopoversState>(this, props);
  }
}
